import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Footer from "../../components/Footer";
import ProductShowcase from "../../components/cultivars/Bubba/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const Bubba = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bubba Kush Cultivar - BeyondBloom™</title>
        <meta name="description" content="Discover Bubba Kush, a premium cultivar from BeyondBloom™. Experience rich flavors, potent effects, and top-tier quality." />
        <meta name="keywords" content="Bubba Kush, Bubba strain, cultivar, BeyondBloom, cannabis, premium plants, greenhouse" />
        <meta name="author" content="BeyondBloom™" />
        
        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Bubba Kush Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Discover Bubba Kush, a premium cultivar from BeyondBloom™. Experience rich flavors, potent effects, and top-tier quality." />
        <meta property="og:image" content="/images/bubba-kush.png" />
        <meta property="og:url" content="https://yourwebsite.com/bubba-kush" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bubba Kush Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Discover Bubba Kush, a premium cultivar from BeyondBloom™. Experience rich flavors, potent effects, and top-tier quality." />
        <meta name="twitter:image" content="/images/bubba-kush.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Bubba;
